import { useQuery } from '@tanstack/react-query';
import { OpportunitiesService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/http-client';

interface UseOpportunitiesCountPreviewParams {
  workspaceId?: string | null;
  dateStart?: Date | null;
  dateEnd?: Date | null;
}

// Hits the admin-scoped clear-count endpoint (not GET /opportunities) so the
// preview mirrors the destructive DELETE path exactly — no duration-based
// expiration filter, unlike the discovery listing.
export const useOpportunitiesCountPreview = (params: UseOpportunitiesCountPreviewParams) => {
  return useQuery({
    queryKey: [
      'opportunities',
      'clear-count',
      params.workspaceId,
      params.dateStart?.toISOString(),
      params.dateEnd?.toISOString(),
    ],
    queryFn: async () => {
      if (!params.workspaceId) {
        return 0;
      }

      const response = await OpportunitiesService.getWorkspaceClearCount({
        client: inferenceHttp,
        query: {
          workspaceId: params.workspaceId,
          dateStart: params.dateStart?.toISOString(),
          dateEnd: params.dateEnd?.toISOString(),
        },
      });

      return response.data?.count ?? 0;
    },
    enabled: !!params.workspaceId,
    // Refetch when date range or workspace changes to show live preview
    placeholderData: (previousData) => previousData,
  });
};
